import axios from 'axios'
import { EvaluationFormSchema } from './evaluationFormManager.validation'
export const EVALUATION_FORMS_ROUTE = 'api/rest/recording/evalform'
export const EXPORT_EVALUATION_FORMS_ROUTE = '/api/rest/cas/download/evalforms'
export const IMPORT_EVALUATION_FORMS_ROUTE = '/api/upload/evalforms'
export const EVALUATION_TEMPLATES_ROUTE = 'api/rest/recording/answergrouptemplate'

// TODO transition fully to RTK api slices
export const getEvaluationForms = async (): Promise<$TSFIXME> => {
  const { data } = await axios.get(`${EVALUATION_FORMS_ROUTE}?exclude=sections`)
  const result = []
  for (const form of data) {
    const parsedForm = EvaluationFormSchema.safeParse(form)
    if (parsedForm.success) {
      result.push(parsedForm.data)
    }
    if (!parsedForm.success && process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console -- TODO: remove this eslint-disable or replace this eslint-disable comment with a proper justification
      console.log('failed to parse form ID', form.id, parsedForm.error.issues)
    }
  }
  return result
}

export const getEvaluationForm = async (key: string, { formId }: { formId: number}): Promise<$TSFIXME> => {
  const { data } = await axios.get(`${EVALUATION_FORMS_ROUTE}/${formId}`)
  // Forms pass through this schema on GET by ID
  const result = EvaluationFormSchema.parse(data[0])
  return result
}

export const importEvaluationForms = async (payload: FormData): Promise<$TSFIXME> => {
  const { data } = await axios.post(IMPORT_EVALUATION_FORMS_ROUTE, payload, { headers: { 'Content-Type': 'multipart/form-data', enctype: 'multipart/form-data' } })
  return data
}
